import React from 'react';

import * as S from '../../stepComponents/styles';
import { AdditionalSupportBox } from '../components/AdditionalSupportBox';
import {
    internationalResources,
    otherResources,
    unitedStatesResources,
} from '../models/pfaProgramData';

export const AdditionalSupportStep: React.SFC = () => {
    return (
        <S.ContentRow>
            <S.ContentColumn>
                <S.StepHeading>Additional Support</S.StepHeading>
                <S.StepDescription small>
                    Get additional support from Modern Health
                </S.StepDescription>
                <S.StepDescription small>
                    Modern Health is not a crisis service. If you are experiencing a crisis (e.g.,
                    suicide, harming yourself or others, medical crisis, or a dangerous situation)
                    please call emergency responders or head to the nearest emergency room. Please
                    see below for a list of relevant resources.
                </S.StepDescription>
            </S.ContentColumn>
            <S.ContentColumn md={12}>
                <AdditionalSupportBox
                    title="United States resources:"
                    resources={unitedStatesResources}
                />
            </S.ContentColumn>
            <S.ContentColumn md={12}>
                <AdditionalSupportBox
                    title="International resources:"
                    resources={internationalResources}
                />
                <AdditionalSupportBox title="Other resources:" resources={otherResources} />
            </S.ContentColumn>
        </S.ContentRow>
    );
};
